import React from 'react';

import { Alert } from 'antd';
import { Link } from 'react-router-dom';

// Explica a diferença entre observador e grupo de consultas nas telas de criação
export default function ObserverTypeAlert({ current, }: { current: 'observer' | 'group' }) {
	return (
		<Alert
			type='info'
			showIcon
			style={{ marginBottom: 16, }}
			message={current === 'observer' ? 'Observador' : 'Grupo de consultas'}
			description={<>
				<div>
					<b>Observador:</b> 1 consulta com condição de alerta. Só notifica quando a condição
					é atingida e gera ocorrência (histórico, dashboard e ✅ de recuperação).
				</div>
				<div>
					<b>Grupo de consultas:</b> várias consultas no mesmo horário, que podem ser cruzadas
					entre si. Sem condição: sempre envia a mensagem e o relatório no horário, sem gerar ocorrência.
				</div>
				<div style={{ marginTop: 4, }}>
					{
						current === 'observer'
							? <Link to='/observador/grupo/adicionar'>Quero criar um grupo de consultas →</Link>
							: <Link to='/observador/adicionar'>Quero criar um observador →</Link>
					}
				</div>
			</>}
		/>
	);
}
